import styles from './Overview.module.scss';

export const OverviewContainer = () => {
    return (
        <div className={styles['overview-container']} id="overview">
            <div className={styles['black-bg']}>
                <div className={styles['frame']}>
                    <div className={styles['title']}>
                        <p>Overview</p>
                        <p>Stamey-White Law</p>
                    </div>
                    <div className={styles['copy-wrapper']}>
                        <p>Navigating the complex world of alcoholic beverage and cannabis law requires specialized
                            knowledge and experienced guidance. At Stamey-White, we provide comprehensive legal services
                            tailored to the unique regulatory needs of businesses in the alcohol and cannabis
                            industries. Whether you’re launching a new venture, managing compliance, or resolving
                            licensing challenges, our expertise ensures you have a trusted advocate every step of the
                            way. With a deep understanding of local, state, and federal regulations, Stamey-White empowers
                            clients to operate confidently and responsibly. From securing licenses to ensuring
                            regulatory compliance, we are dedicated to supporting the growth and integrity of your
                            business in these evolving industries.</p>
                    </div>
                </div>
            </div>
        </div>
    )
};